/**
 * about / message セクションの「pin + 内部スクロール」 演出。
 *
 * - section (CSS で sticky top: 0, height: 100vh) を画面に固定
 * - ユーザーの scroll に応じて section の中身 ([data-pin-inner] or firstElementChild) を
 *   transform: translateY で上にスライドさせて 「画面固定の中で内部 scroll する」 演出を実現
 * - 中身が全て上に流れ切ったら translate を固定 (overlap range に入って次セクションが上に被さってくる)
 *
 * #about の鶴 wrap (data-crane-wrap) の進入アニメ (top-about-crane.js) とは独立に動作。
 * 鶴 wrap は about の中の child なので、 transform translateY が適用された親と一緒に動く。
 */
(function () {
  'use strict';

  /* getEffectiveZoom は assets/zoom-utils.js (window.HakotsuruZoom) に集約。
     theme.liquid で本スクリプトより前に読み込む。 */
  var zoomUtil = window.HakotsuruZoom;

  function setupPin(section) {
    if (!section) return;
    var inner = section.querySelector(':scope > [data-pin-inner]') || section.firstElementChild;
    if (!inner) return;
    var wrap = section.closest('div[id^="shopify-section"]');
    if (!wrap) return;

    var rafId = null;
    function compute() {
      rafId = null;
      var zoom = zoomUtil.getEffectiveZoom(section);
      var wrapRect = wrap.getBoundingClientRect();
      var wrapTopVp = wrapRect.top / zoom;  /* viewport 上の wrap.top (layout 単位) */
      var vh = window.innerHeight;
      var innerHeight = inner.scrollHeight;
      var contentSlide = Math.max(0, innerHeight - vh);
      /* 0.5 viewport 分の scroll で content が contentSlide 動く (= 線形 scrub)。
         wrap.height = 300vh のうち最初の 0.5vh で scrub 完了、 次の 0.5vh で
         CTA 等を画面に静止させてユーザーに視認させ、 残り 1vh で message overlap。 */
      var scrollRange = vh * 0.5;

      var translateY;
      if (wrapTopVp > 0) {
        translateY = 0;
      } else if (-wrapTopVp < scrollRange) {
        var progress = -wrapTopVp / scrollRange;
        translateY = -progress * contentSlide;
      } else {
        translateY = -contentSlide;
      }
      inner.style.transform = 'translateY(' + translateY + 'px)';
    }

    function schedule() {
      if (rafId != null) return;
      rafId = window.requestAnimationFrame(compute);
    }

    compute();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  }

  function init() {
    setupPin(document.getElementById('about'));
    setupPin(document.getElementById('message'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
